import React, { createContext, useState, ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronLeft, ChevronRight, Sun, Moon } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';

// Sidebar Context for managing expanded state

export const SidebarContext = createContext(
  undefined
);
export default function Sidebar({ children }) {
    const [expanded, setExpanded] = useState(false);
    const [theme, setTheme] = useState('light');
    const [status, setStatus] = useState(true);
    const navigate = useNavigate();
  
    const darkMode = theme === 'dark';
  
    const toggleTheme = () => setTheme(darkMode ? 'light' : 'dark');

    const{logout} = useAuth()
  
    const handleLogout = () => {
      logout()
      navigate('/login'); // Redirect to the login page
    };
  
    return (
      <aside className="h-screen ">
        <nav className="h-full flex flex-col bg-gray-100 dark:bg-gray-800 shadow-md">
          {/* Header with toggle */}
          <div className="p-4 pb-2 flex justify-between items-center">
            <h1
              className={`overflow-hidden transition-all font-bold ${
                expanded ? 'block' : 'hidden'
              }`}
            >
              Invoice Hub
            </h1>
            <button
              onClick={() => setExpanded((curr) => !curr)}
              className="p-2 rounded-lg bg-gray-200 hover:bg-gray-300 dark:bg-gray-700 dark:hover:bg-gray-600"
            >
              {expanded ? (
                <ChevronLeft className="w-5 h-5" />
              ) : (
                <ChevronRight className="w-5 h-5" />
              )}
            </button>
          </div>
  
          {/* Sidebar items */}
          <SidebarContext.Provider value={{ expanded }}>
            <ul className="flex-1 px-3">{children}</ul>
          </SidebarContext.Provider>
  
          {/* User dropdown */}
          <div className="border-t border-gray-300 dark:border-gray-700 flex p-3 items-center relative flex-col">
         
  
            {/* Logout Button */}
            <button
              onClick={handleLogout}
              className={`mt-3 px-3 py-2 rounded-md text-sm w-full flex items-center justify-center transition-all ${
                expanded
                  ? 'bg-red-500 text-white hover:bg-red-600 dark:bg-red-600 dark:hover:bg-red-700'
                  : 'bg-transparent text-gray-800 dark:text-gray-200 hover:bg-gray-200 dark:hover:bg-gray-700'
              }`}
            >
              {expanded ? (
                'Logout'
              ) : (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="w-5 h-5"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  strokeWidth={2}
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H4a3 3 0 01-3-3v-1m0-4V7a3 3 0 013-3h6a3 3 0 013 3v1"
                  />
                </svg>
              )}
            </button>
          </div>
        </nav>
      </aside>
    );
  }
  